/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { CssTextField } from 'components/select';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import style from 'pages/user-preferences/style';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';

function ToDate() {
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [open, setOpen] = React.useState(false);
    const minDate = order?.startDate ? new Date(order?.startDate) : new Date();
    const maxDate = new Date(minDate);
    maxDate?.setMonth(maxDate?.getMonth() + 6); // Add 6 months to startDate
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                inputFormat="yyyy-MM-dd"
                minDate={minDate}
                maxDate={maxDate}
                label="To Date *"
                value={order?.endDate || null}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                onChange={(value) => {
                    setOrder((prevOrder) => ({
                        ...prevOrder,
                        endDate: value,
                    }));
                    setOpen(false);
                }}
                PopperProps={{
                    // Set the desired placement for the Popper element
                    placement: 'top-start',
                    // Set zIndex to ensure the Popper is always on top
                    style: { zIndex: 9999 },
                }}
                renderInput={(params) => <CssTextField {...params} sx={style.textField} data-testid="ToDate" onClick={() => setOpen(true)} />}
            />
        </LocalizationProvider>
    );
}

export default ToDate;
